function appendQueryToShopifyImageUrl(url, query) {
  const urlParts = url.split("?");
  const baseUrl = urlParts[0];
  const queryString = urlParts[1] || "";

  const extensionMatch = baseUrl.match(/\.(jpg|jpeg|png|webp|gif|bmp|tiff)$/i);
  if (!extensionMatch) {
    return url;
  }

  const extensionIndex = extensionMatch.index;
  const modifiedBaseUrl = `${baseUrl.slice(
    0,
    extensionIndex
  )}_${query}${baseUrl.slice(extensionIndex)}`;

  return queryString ? `${modifiedBaseUrl}?${queryString}` : modifiedBaseUrl;
}

if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.elSection = this.closest("section");
      this.elForm = this.querySelector("form");
      this.elVariant = this.elForm.querySelector('[name="id"]');
      this.elQuantity = this.elForm.querySelector('[name="quantity"]');
      this.elProperties = this.elForm.querySelectorAll(
        "input[name^='properties']"
      );
      this.elSubmit = this.elForm.querySelector('button[type="submit"]');
      this.elSubmitCopy = this.elSubmit.querySelector("[data-copy]");
      this.elPrice = this.querySelector("[data-product-price]");
      this.elCap = this.querySelector("[data-product-cap]");
      this.elSubscriptionPrice = this.querySelector(
        "[data-subscription-price]"
      );
      this.elSubscriptionCap = this.querySelector("[data-subscription-cap]");
      this.elServingPrices = this.querySelectorAll("[data-serving-price]");
      this.elSellingPlans = this.querySelectorAll('[name="selling_plan"]');
      this.elQuantity = this.querySelector('input[name="quantity"]');
      this.elPurchaseOptions = this.querySelectorAll('[name="subscription"]');
      this.elVariants = this.querySelector("[data-variants]");
      this.elStatus = this.elForm.querySelector("[data-status]");
      this.elMedia = this.elSection.querySelector("[data-product-media]");
      this.elIngredients = this.elSection.querySelector("[data-ingredients]");
      this.variantImagesData = document.getElementById("variant-images-data")
        ? JSON.parse(document.getElementById("variant-images-data").innerHTML)
        : {};

      if (this.elMedia && this.elMedia.swiper) {
        this.originalProductSlides = Array.from(
          this.elMedia.querySelectorAll(
            '.swiper-slide[data-default-media="true"]'
          )
        ).map((el) => {
          const node = el.cloneNode(true);
          node.classList.remove("none-important");
          return node;
        });
      }

      this.variants = JSON.parse(this.elVariants.innerHTML);
      this.currentVariant = this.variants.find(
        (v) => v.id == this.elVariant.value
      );
      this.currentOptions = { ...this.currentVariant.options };
      this.currentQuantity = Number(this.elQuantity.value);
      this.currentSubscription = !this.currentVariant.onetime_only
        ? this.currentVariant.selling_plans.find((plan) => plan.selected)
        : null;
      this.currentSellingPlanLabel = this.querySelector("#selling_plan")
        .parentNode.querySelector("[data-selected]")
        .textContent.replace(/(\r\n|\n|\r)/gm, "");
      this.hasSubscription = !!this.currentSubscription;

      this.showHideWaitlist();
      this.elForm.addEventListener("change", this.onFormChange.bind(this));
      this.elForm.addEventListener("submit", this.addToCart.bind(this));

      document.addEventListener(
        "countdown-finished",
        this.handleCountdownFinished.bind(this)
      );

      this.preselectSubscription();
      this.updateServingPrice();
      this.updateVariantTag();
    }

    handleCountdownFinished() {
      if (this.elForm.classList.contains("waitlist-active")) {
        this.elForm.classList.remove("waitlist-active");

        const countdownContainer = document.querySelector(
          "[data-variant-waitlist]"
        );
        if (countdownContainer) {
          countdownContainer.style.display = "none";
        }
      }
    }

    onFormChange({ target }) {
      (target.name == "subscription" || target.name == "selling_plan") &&
        this.setCurrentSubscription(target.name, target.value);
      target.name.includes("option") &&
        this.setCurrentVariant(target.name, target.value);
      target.name == "quantity" && this.setCurrentQuantity(target.value);
    }

    setCurrentSubscription(name, value) {
      this.hasSubscription =
        name == "subscription" ? value !== "onetime" : this.hasSubscription;
      this.currentSubscription =
        name == "selling_plan"
          ? this.currentVariant.selling_plans.find(
              (plan) => plan.id == Number(value)
            )
          : this.currentSubscription;
      this.currentSubscription &&
        (this.currentSellingPlanLabel = this.currentSubscription.name);
      this.updatePrice();
      this.updateServingPrice();
    }

    setCurrentVariant(option, value) {
      this.currentOptions[option] = value;
      this.currentVariant = this.variants.find(
        (variant) =>
          JSON.stringify(variant.options) == JSON.stringify(this.currentOptions)
      );
      this.currentSubscription = this.currentVariant.onetime_only
        ? null
        : this.currentVariant.selling_plans.find(
            (plan) => plan.name == this.currentSellingPlanLabel
          );

      this.elPurchaseOptions.forEach((el) => {
        const isSubscription = el.value.includes("subscription");
        const shouldDisable = isSubscription
          ? this.currentVariant.onetime_only
          : this.currentVariant.subscription_only;
        const shouldUncheck = shouldDisable && el.checked;
        el.toggleAttribute("disabled", shouldDisable);
        el.checked = !shouldUncheck;
        el.checked && el.dispatchEvent(new Event("change", { bubbles: true }));
      });

      this.preselectSubscription();

      this.elSubmit.disabled = !this.currentVariant.available;
      this.updatePrice();
      this.updateServingPrice();

      document.body.style.setProperty(
        "--color-background",
        this.currentVariant.color
      );
      this.updateMediaCarousel();
      this.updateVariantImages();
      this.updateIngredients();
      this.showHideWaitlist();

      // window.history.replaceState({}, "", this.currentVariant.url);
    }

    updateVariantImages() {
      if (!this.elMedia || !this.elMedia.swiper) return;

      this.elMedia.classList.add("loading-variant");

      const variantId = this.currentVariant.id;
      const hasCustomImages =
        this.variantImagesData && this.variantImagesData[variantId];

      const variantSlides = this.elMedia.querySelectorAll(
        '.swiper-slide[data-variant-media="true"]'
      );

      const preloadImages = (images) => {
        return Promise.all(
          images.map((image) => {
            return new Promise((resolve) => {
              const img = new Image();
              img.onload = () => resolve(image);
              img.onerror = () => resolve(image);
              img.src = image.src;
            });
          })
        );
      };

      if (hasCustomImages) {
        this.elMedia
          .querySelectorAll('.swiper-slide[data-default-media="true"]')
          .forEach((slide) => {
            slide.classList.add("none-important");
          });

        const currentVariantSlides = Array.from(variantSlides).filter(
          (slide) => slide.getAttribute("data-variant-id") === String(variantId)
        );

        if (currentVariantSlides.length > 0) {
          variantSlides.forEach((slide) => {
            if (slide.getAttribute("data-variant-id") === String(variantId)) {
              slide.style.display = "";
              slide.classList.remove("loading");
            } else {
              slide.style.display = "none";
            }
          });

          const firstSlideIndex = Array.from(
            this.elMedia.swiper.slides
          ).indexOf(currentVariantSlides[0]);
          if (firstSlideIndex !== -1) {
            this.elMedia.swiper.slideTo(firstSlideIndex, 0);
          }

          setTimeout(() => {
            this.elMedia.classList.remove("loading-variant");
          }, 100);
        } else {
          variantSlides.forEach((slide) => {
            if (slide.getAttribute("data-variant-id") !== String(variantId)) {
              this.elMedia.swiper.removeSlide(
                Array.from(this.elMedia.swiper.slides).indexOf(slide)
              );
            }
          });

          const variantImages = this.variantImagesData[variantId];
          const slides = [];

          variantImages.forEach((image, index) => {
            const slide = document.createElement("div");
            slide.className = "product-media--slide swiper-slide loading";
            slide.setAttribute("data-index", index);
            slide.setAttribute("data-variant-media", "true");
            slide.setAttribute("data-variant-id", variantId);

            const figure = document.createElement("figure");

            const placeholder = document.createElement("div");
            placeholder.className = "product-media-placeholder";
            figure.appendChild(placeholder);

            slide.appendChild(figure);
            slides.push(slide);
          });

          slides.reverse().forEach((slide) => {
            this.elMedia.swiper.addSlide(0, slide);
          });

          this.elMedia.swiper.slideTo(0, 0);

          preloadImages(variantImages).then(() => {
            variantImages.forEach((image, index) => {
              const slideIndex = slides.length - 1 - index;
              const slide = slides[slideIndex];
              const figure = slide.querySelector("figure");
              const placeholder = figure.querySelector(
                ".product-media-placeholder"
              );

              if (placeholder) {
                const img = document.createElement("img");
                img.src = image.src;
                img.alt = image.alt || this.currentVariant.title;
                img.className = "cover";
                img.setAttribute("width", image.width);
                img.setAttribute("height", image.height);
                img.setAttribute("fetchpriority", "high");

                const widths = [375, 750, 928, 1108, 1500, 1856, 2216];
                const srcset = widths
                  .map((width) => {
                    const srcWithWidth = appendQueryToShopifyImageUrl(
                      image.src,
                      `${width}x`
                    );
                    return `${srcWithWidth} ${width}w`;
                  })
                  .join(", ");

                img.setAttribute("srcset", srcset);
                img.setAttribute(
                  "sizes",
                  "(min-width: 1680px) 1108px, (min-width: 1024px) 66vw, 100vw"
                );

                figure.replaceChild(img, placeholder);
                slide.classList.remove("loading");
              }
            });

            setTimeout(() => {
              this.elMedia.classList.remove("loading-variant");
            }, 200);
          });
        }

        const totalSlides = this.elMedia.swiper.slides.filter(
          (slide) =>
            slide.style.display !== "none" &&
            !slide.classList.contains("none-important")
        ).length;

        const elTooltip = this.elMedia.querySelector("tooltip-component");
        if (elTooltip) {
          const totalText = totalSlides < 10 ? `0${totalSlides}` : totalSlides;
          elTooltip.innerHTML = `<span data-product-media-current>01</span>/${totalText}`;
        }
      } else {
        variantSlides.forEach((slide) => {
          const slideIndex = Array.from(this.elMedia.swiper.slides).indexOf(
            slide
          );
          if (slideIndex !== -1) {
            this.elMedia.swiper.removeSlide(slideIndex);
          }
        });

        const currentProductSlides = this.elMedia.querySelectorAll(
          '.swiper-slide[data-default-media="true"]'
        );

        if (
          currentProductSlides.length === 0 ||
          Array.from(currentProductSlides).every((slide) =>
            slide.classList.contains("none-important")
          )
        ) {
          currentProductSlides.forEach((slide) => {
            const slideIndex = Array.from(this.elMedia.swiper.slides).indexOf(
              slide
            );
            if (slideIndex !== -1) {
              this.elMedia.swiper.removeSlide(slideIndex);
            }
          });

          if (
            this.originalProductSlides &&
            this.originalProductSlides.length > 0
          ) {
            this.originalProductSlides.forEach((originalSlide, index) => {
              const newSlide = originalSlide.cloneNode(true);
              newSlide.classList.add("loading");

              const figure = newSlide.querySelector("figure");
              if (figure) {
                const img = figure.querySelector("img");
                if (img) {
                  const placeholder = document.createElement("div");
                  placeholder.className = "product-media-placeholder";
                  placeholder.setAttribute("data-original-img", "");
                  figure.insertBefore(placeholder, img);
                  img.style.opacity = "0";

                  const loadImg = () => {
                    setTimeout(() => {
                      if (img.complete) {
                        placeholder.remove();
                        img.style.opacity = "1";
                        newSlide.classList.remove("loading");
                      } else {
                        img.onload = () => {
                          placeholder.remove();
                          img.style.opacity = "1";
                          newSlide.classList.remove("loading");
                        };
                      }
                    }, 100);
                  };

                  loadImg();
                }
              }

              this.elMedia.swiper.appendSlide(newSlide);
            });
          }
        } else {
          currentProductSlides.forEach((slide) => {
            slide.classList.remove("none-important");
          });
        }

        const totalSlides = this.elMedia.querySelectorAll(
          '.swiper-slide[data-default-media="true"]'
        ).length;

        const elTooltip = this.elMedia.querySelector("tooltip-component");
        if (elTooltip) {
          const totalText = totalSlides < 10 ? `0${totalSlides}` : totalSlides;
          elTooltip.innerHTML = `<span data-product-media-current>01</span>/${totalText}`;
        }

        this.updateMediaCarousel();
      }

      setTimeout(() => {
        this.elMedia.classList.remove("loading-variant");
      }, 300);
    }

    preselectSubscription() {
      if (
        !this.currentVariant.onetime_only &&
        this.currentVariant.selling_plans &&
        this.currentVariant.selling_plans.length > 0
      ) {
        const subscriptionOption = Array.from(this.elPurchaseOptions).find(
          (el) =>
            el.name === "subscription" &&
            el.value.includes("subscription-") &&
            !el.disabled
        );

        if (subscriptionOption && !subscriptionOption.checked) {
          subscriptionOption.checked = true;
          this.hasSubscription = true;

          const groupId = subscriptionOption.value.replace("subscription-", "");

          const firstPlan = this.currentVariant.selling_plans.find(
            (plan) => plan.id == groupId
          );
          if (firstPlan) {
            this.currentSubscription = firstPlan;
            this.currentSellingPlanLabel = firstPlan.name;

            const sellingPlanSelect = this.querySelector("#selling_plan");
            if (sellingPlanSelect) {
              const option = Array.from(sellingPlanSelect.options).find(
                (opt) => opt.value == firstPlan.id
              );
              if (option) {
                sellingPlanSelect.value = firstPlan.id;
                const customSelect = sellingPlanSelect.parentNode;
                const selectedSpan =
                  customSelect.querySelector("[data-selected]");
                if (selectedSpan) {
                  selectedSpan.textContent = firstPlan.name;
                }
              }
            }

            subscriptionOption.dispatchEvent(
              new Event("change", { bubbles: true })
            );
          }
        }
      }
    }

    setCurrentQuantity(quantity) {
      this.currentQuantity = Number(quantity);
      this.updatePrice();
    }

    updateServingPrice() {
      this.elServingPrices.forEach((el) => {
        const servingsSize = Number(el.getAttribute("data-serving-price"));
        if (!servingsSize) return;

        const parentLabel = el.closest("label");
        if (!parentLabel) return;

        const inputId = parentLabel.getAttribute("for");
        const input = document.getElementById(inputId);

        if (input && input.checked) {
          let currentPrice;
          if (this.hasSubscription && this.currentSubscription) {
            currentPrice = this.currentSubscription.price;
          } else {
            currentPrice = this.currentVariant.price;
          }

          const servingPrice = Math.floor(currentPrice / servingsSize);
          el.innerHTML = `${formatMoney(servingPrice, 0)} per serving`;
        }
      });
    }

    updatePrice() {
      this.elPrice.innerHTML = formatMoney(
        this.currentVariant.price * this.currentQuantity,
        0
      );
      this.currentVariant.cap &&
        (this.elCap.innerHTML = formatMoney(
          this.currentVariant.cap * this.currentQuantity,
          0
        ));

      if (this.currentSubscription) {
        this.elSubscriptionPrice.innerHTML = formatMoney(
          this.currentSubscription.price * this.currentQuantity,
          0
        );
        this.elSubscriptionCap &&
          (this.elSubscriptionCap.innerHTML = formatMoney(
            this.currentSubscription.cap * this.currentQuantity,
            0
          ));
      }

      const price =
        this.currentSubscription && this.hasSubscription
          ? this.currentSubscription.price
          : this.currentVariant.price * this.currentQuantity;
      const finalPrice = formatMoney(price, 0);

      this.elSubmitCopy.innerHTML = this.currentVariant.available
        ? `Add to Cart – ${finalPrice}`
        : "Sold Out";

      this.updateServingPrice();
    }

    updateMediaCarousel() {
      const elSlide = [...this.elMedia.querySelectorAll(".swiper-slide")].find(
        (el) => {
          const variants = el.dataset.variants
            ? JSON.parse(el.dataset.variants).map((id) => Number(id))
            : null;
          return variants && variants.includes(this.currentVariant.id);
        }
      );

      if (elSlide) {
        const index = Number(elSlide.getAttribute("data-index"));
        this.elMedia.swiper.slideTo(index, 0);
      }
    }

    updateIngredients() {
      if (this.elIngredients && this.currentVariant.ingredients) {
        this.elIngredients.innerHTML = this.currentVariant.ingredients;
      }
    }

    showHideWaitlist() {
      if (this.currentVariant.waitlist) {
        this.elForm.classList.add("waitlist-active");

        const elWaitlist = document.createElement("div");
        elWaitlist.setAttribute("data-variant-waitlist", "");
        elWaitlist.innerHTML = this.currentVariant.waitlist;

        this.appendChild(elWaitlist);
      } else {
        const elWaitlist = this.querySelector("[data-variant-waitlist]");
        this.elForm.classList.remove("waitlist-active");
        elWaitlist && elWaitlist.remove();
      }
    }

    addToCart(ev) {
      ev.preventDefault();
      const { id } = this.currentVariant;

      const properties = this.elProperties
        ? Object.assign(
            {},
            ...[...this.elProperties].map((el) => {
              const name = el.name.split("properties[")[1].split("]")[0];
              return { [name]: el.value };
            })
          )
        : {};

      const data = {
        id,
        quantity: this.currentQuantity,
        properties: {
          ...properties,
        },
        ...(this.hasSubscription
          ? { selling_plan: this.currentSubscription.id }
          : ""),
      };

      this.classList.add("adding");
      this.elStatus.innerHTML = `<span>Adding <span class="visually-hidden">${this.currentVariant.title} to cart</span>...</span>`;
      this.elSubmit.disabled = true;

      window.addToCart(data).then((response) => {
        this.classList.remove("adding");
        if (response.status) {
          this.classList.add("error");
          this.elStatus.innerHTML = `<span>Error<span class="visually-hidden"> adding ${this.currentVariant.title} to cart</span></span>`;
        } else {
          this.classList.add("success");
          this.elStatus.innerHTML = `<span>Added<span class="visually-hidden">${this.currentVariant.title}</span> to cart</span>`;
        }
        setTimeout(() => this.resetState(), 5000);
      });
    }

    resetState() {
      this.classList.remove("error");
      this.classList.remove("success");
      this.elSubmit.disabled = false;
      setTimeout(() => {
        this.elStatus.innerHTML = "";
      }, 300);
    }
  }

  customElements.define("product-form", ProductForm);
}
